import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getSalons = async (id?: any, search?: string, tab?: string) => {
    const query = supabase
        .from('services')
        .select(`*, salon(*), menu_category(name)`)

    if (id) {
        query.eq('menu_category', id)
    }

    if (search) {
        query.ilike('name', `%${search}%`); // Ищет частичное совпадение в поле name
    }

    if (tab) {
        query.eq('type', tab)
    }

    const { data, error } = await query;

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllSalons(id?: any, search?: string, tab?: string) {
    return useQuery({
        queryKey: ['useGetAllSalons', id, search, tab],
        queryFn: () => getSalons(id, search, tab),
        staleTime: 0,
    })
}
